angular.module('unergie.main')
.directive('userInfoContractDeposit', (TableGeneratorService, PaymentService, BoFeaturesService, DataAccess, AlertManager, MetaWatcher, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/contract/userInfoContractDeposit.html',
        link($scope) {
            $scope.deposits = {
                columns: {
                    id: { label: 'id', mode: 'hidden' },
                    status: { label: 'Status', mode: 'search_operator' },
                    amount: { label: 'Montant', mode: 'search_operator' },
                    payment_date: { label: 'Date de paiement', mode: 'search_date' },
                    external_ref: { label: 'Ref. payline', mode: 'search_wildcard' },
                    label: { label: 'Libellé du paiement', mode: 'search_operator' },
                },
            }

            $scope.showReimburseDeposit = BoFeaturesService.isFeatureOn('canReimburseDeposit')

            $scope.canRefundCbDeposit = () => PaymentService.canRefundCbDeposit($scope.contract)
            $scope.refundCbDeposit = (deposit) =>
                PaymentService.refundCbDeposit(deposit).then(() => MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract))

            $scope.paymentNotYetValidated = PaymentService.paymentNotYetValidated
            $scope.getSimplePaymentStatus = PaymentService.getSimplePaymentStatus

            $scope.refresh = () => TableGeneratorService.getTable($scope.deposits, 'security-deposit', '', null, { search: { id_contract: $scope.contract.id } })

            $scope.isRefundable = (deposit) => moment(deposit.payment_date).isAfter(moment().add(-1, 'year'))

            const activate = () => $scope.refresh()

            return activate()
        },
    }),
)
